import {
  HotelDetailFeatureCategoryViewModel,
  RoomLowestPriceViewModel,
} from '@api/v3';

export const getSkipassControl = (
  badge?: HotelDetailFeatureCategoryViewModel[]
) => {
  const targetItem = badge?.find((item) => item.name === 'Aktiviteler');
  if (!targetItem) return false;

  return !!targetItem.features?.find(
    (item) => item.name === 'Skipass' && item.badge
  );
};
export const getTransferServiceControl = (
  badge?: HotelDetailFeatureCategoryViewModel[]
) => {
  const targetItem = badge?.find((item) => item.name === 'Tesis Hizmetleri');
  if (!targetItem) return false;

  return !!targetItem.features?.find(
    (item) => item.name === 'Transfer Servisi' && item.badge
  );
};
export interface SummaryCardPriceProps {
  prices?: RoomLowestPriceViewModel;
  isExpedia?: boolean;
  entryDateMissing?: boolean;
  bankInstallMentForWorld?: string;
  showSeturEmployeePrice?: boolean;
  roomInformation?: string;
  onNavigate?: () => void;
  isPackage?: boolean;
  countryCode?: string;
  basketHotelCount?: number;
}
